import { AxiosResponse } from "axios";
import { deleteAsync, getAsync, postAsync, putAsync } from "./client";
import { WhyChoose } from "../@type/whychoose";

class WhyChooseService {
  get = async (params: any): Promise<AxiosResponse> => {
    try {
      const response = await getAsync('flower-features', {
        ...params,
      });
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; 
    }
  }
  getById = async (_id: any): Promise<AxiosResponse> => {
    return await getAsync(`/product/${_id}`)
  }
  post = async (productData: any): Promise<AxiosResponse> => {
    return await postAsync('/product',productData);
  }
  delete = async (_id: any): Promise<AxiosResponse> => {
    return await deleteAsync(`/product/${_id}`);
  }
    updateById = async (id: any, data: WhyChoose): Promise<AxiosResponse> => {
      return await putAsync(`flower-features/${id}`, data);
    }
}

const whyChooseService = new WhyChooseService();

export default whyChooseService;
